import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import InternalGate from './pages/InternalGate'
import ErrorBoundary from './components/ErrorBoundary'
import 'bootstrap-icons/font/bootstrap-icons.css';
import './styles.css';

/**
 * Globally suppress the mouse-wheel spinner on focused number inputs.
 * HTML's <input type="number"> changes value on wheel when focused —
 * Ananya 06-30 #5 caught the discount Value field jumping from 60 to
 * 59.99 just by scrolling the page. Blurring on wheel keeps scroll
 * working as page-scroll and removes the accidental edits, while
 * still letting users use arrow keys + the spinner buttons.
 */
document.addEventListener('wheel', (e) => {
  const t = e.target;
  if (t instanceof HTMLInputElement && t.type === 'number' && t === document.activeElement) {
    t.blur();
  }
}, { passive: true });

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <ErrorBoundary>
      <InternalGate><App /></InternalGate>
    </ErrorBoundary>
  </React.StrictMode>,
);
